"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lantern = {
    resourceID: "lantern",
    url: "/lantern.png",
    spriteSize: 32,
    layers: {
        ["lantern_dark"]: {
            layerID: "lantern_dark",
            resourceID: "lantern",
            sprite: { x: 0, y: 0 },
        },
        ["lantern_lit"]: {
            layerID: "lantern_lit",
            resourceID: "lantern",
            sprite: { x: 0, y: 1 },
        },
        ["pedestal_dark"]: {
            layerID: "pedestal_dark",
            resourceID: "lantern",
            sprite: { x: 1, y: 1 },
        },
        ["pedestal_lit"]: {
            layerID: "pedestal_lit",
            resourceID: "lantern",
            sprite: { x: 1, y: 0 },
        },
    },
};
exports.default = lantern;
//# sourceMappingURL=lantern.js.map